import { Component, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import {
  StringCustomFieldConfig,
  SharedModule,
  FormInputComponent,
} from "@bb-vendure/admin-ui/core";

@Component({
  standalone: true,
  imports: [SharedModule],
  templateUrl: "./shipping-setting-dropdown.component.html",
})
export class ShippingSettingDropdownComponent
  implements FormInputComponent<StringCustomFieldConfig>, OnInit
{
  ngOnInit(): void {}
  isListInput?: boolean = false;
  readonly: boolean;
  formControl: FormControl<any>;
  config: StringCustomFieldConfig;

  shippingSettings = ["Quantity", "Weight"];
}
